import { KeyCodes } from '@corp/constants/keyboard'

// Public: Helper to emit a close event detected by DialogManager.
export function notifyCloseDialog (el: Element, originalEvent?: Event | undefined) {
  const event = createNewEvent('dialog-close', { id: el.id, originalEvent, bubbles: false, cancelable: true })
  el.dispatchEvent(event)
}

export function createNewEvent<T = {}> (
  eventName: string,
  { bubbles, cancelable, detail, ...options }: Partial<CustomEvent> & T = {} as any,
) {
  const event = new CustomEvent(eventName, { bubbles, cancelable, detail })
  return Object.assign(event, options)
}

export function keyFor (event: KeyboardEvent) {
  // Events are missing `key` in integration tests (synthetic events).
  if (import.meta.env.MODE === 'test')
    return KeyCodes[event.keyCode] || console.warn(`You must define '${event.keyCode}' in KeyCodes`)

  return event.key
}
